/** @jsx h */
import { labels } from '../config';
import { Fragment } from 'preact';
import { useEffect, useRef, useState } from 'preact/hooks';
import axios from 'axios';
import { LazerLoader } from 'modules/lazer-loader';

const CalendarItem = ({ result }) => {
  const itemRef = useRef(null);
  const subBoxRef = useRef(null);
  const [indices, setIndices] = useState([]);
  const [hasFetchedIndices, setHasFetchedIndices] = useState(false);

  useEffect(() => {
    new LazerLoader({
      targets: [itemRef.current],
      config: { rootMargin: '200px' },
      cb: () => fetchIndices(result.indicesUrl),
    }).init();
  }, []);

  function fetchIndices(indicesUrl) {
    if (hasFetchedIndices) return;
    axios
      .get(indicesUrl)
      .then(({ data }) => {
        setIndices(data);
        setHasFetchedIndices(true);
      })
      .catch(error => {
        console.error(error);
      });
  }

  return (
    <li className="teaser-list__item" ref={itemRef}>
      <div className="teaser-list__item-inner">
        <div className="teaser-list__date-box">
          <time
            className="teaser-list__date"
            dangerouslySetInnerHTML={{ __html: result.dateText }}
          />

          {indices.length > 0 && (
            <Fragment>
              <div className="teaser-list__time-wrapper">
                <button
                  className="teaser-list__time-button"
                  onClick={() =>
                    subBoxRef.current.classList.toggle('is-active')
                  }
                  type="button"
                >
                  <i className="icon-cross" aria-hidden="true" />
                  <span className="sr-only">
                    {labels.results.moreCalendarDates}
                  </span>
                </button>
              </div>
              <ul className="teaser-list__subdate-box" ref={subBoxRef}>
                {indices.map(index => (
                  <li
                    className="teaser-list__subtime"
                    key={`${result.indicesUrl}-${index}`}
                  >
                    <span className="teaser-list__subdate">{index}</span>
                  </li>
                ))}
              </ul>
            </Fragment>
          )}
        </div>

        <a href={result.url} className="teaser-list__image-link">
          <picture className="teaser-list__picture">
            <img
              className="teaser-list__image"
              alt={result.image?.alt}
              src={result.image?.src}
              loading="lazy"
            />
          </picture>
        </a>

        <div className="teaser-list__context">
          <div className="teaser-list__subtitle">
            {result.type === 'event' ? (
              <span>{result.eventTypes && result.eventTypes.join(', ')}</span>
            ) : (
              <a href={result.subtitleUrl} className="link--intern">
                <span>{result.subtitle}</span>
              </a>
            )}
          </div>

          {result.title ? (
            <h3 className="teaser-list__title">
              <a href={result.url} className="link">
                {result.title}
              </a>
            </h3>
          ) : (
            ''
          )}

          {result.type === 'movieIndex' &&
            (result.isCompactLayout ? (
              result.movieTitles.map(movieTitle => (
                <div className="teaser-list__detail" key={movieTitle}>
                  <p>{movieTitle}</p>
                </div>
              ))
            ) : result.director || result.country || result.year ? (
              <div className="teaser-list__detail">
                <p>
                  {result.director} {result.country} {result.year}
                </p>
              </div>
            ) : (
              ''
            ))}

          {result.type === 'event' ? (
            <div className="teaser-list__text">
              <p>{result.teaser}</p>
            </div>
          ) : (
            <div className="teaser-list__text teaser-list__text--color">
              <p>{result.teaser}</p>
            </div>
          )}

          {result.type === 'movieIndex' &&
          !result.isCompactLayout &&
          (result.filmFormat ||
            result.languageVersion ||
            result.playingTime) ? (
            <div className="teaser-list__label">
              <p>
                {result.filmFormat} {result.languageVersion}{' '}
                {result.playingTime}
              </p>
            </div>
          ) : (
            ''
          )}

          <div className="teaser-list__info">
            {result.location ? (
              <p className="teaser-list__info-text">{result.location}</p>
            ) : (
              ''
            )}

            {result.salesUrl ? (
              <a
                href={result.salesUrl}
                className="teaser-list__info-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i
                  className="teaser-list__info-icon icon-ticket"
                  aria-hidden="true"
                />
                <span className="sr-only">{labels.results.tickets}</span>
              </a>
            ) : (
              ''
            )}

            {result.icsUrl ? (
              <a href={result.icsUrl} className="teaser-list__info-link">
                <i
                  className="teaser-list__info-icon icon-calendar"
                  aria-hidden="true"
                />
                <span className="sr-only">{labels.results.saveToCalendar}</span>
              </a>
            ) : (
              ''
            )}
          </div>
        </div>
      </div>
    </li>
  );
};

export default CalendarItem;
